import { PropsWithChildren } from 'react'
import styles from './Container.module.css'

const Container = ({ children, className }: PropsWithChildren<{ className?: string }>) => (
  <div className={`${styles.container} ${className}`}>{children}</div>
)

export default Container
